import React, { createContext, useContext, useState, useEffect } from 'react';

const QuestCtx = createContext(null);

const KEY = 'cq_session_v1';

export function QuestProvider({ children }) {
  const [session, setSession] = useState(() => {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : { player: null, answers: [], xp: 0, badges: [], leadId: null, result: null, token: null, invite: null };
    } catch {
      return { player: null, answers: [], xp: 0, badges: [], leadId: null, result: null, token: null, invite: null };
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(session));
  }, [session]);

  const reset = () => setSession({ player: null, answers: [], xp: 0, badges: [], leadId: null, result: null, token: null, invite: null });

  return (
    <QuestCtx.Provider value={{ session, setSession, reset }}>
      {children}
    </QuestCtx.Provider>
  );
}

export function useQuest() {
  const v = useContext(QuestCtx);
  if (!v) throw new Error('useQuest must be used inside QuestProvider');
  return v;
}
